import { Component, OnInit } from "@angular/core";

@Component({
  selector: "vc-default-desktop-item",
  templateUrl: "./default-desktop-item.component.html",
  styleUrls: ["./default-desktop-item.component.scss"],
})
export class DefaultDesktopItemComponent {
}
